import { create } from 'zustand'
import { permissionsApi } from '@/api/permissions'

interface PermissionState {
	permissions: string[]
	isSuperAdmin: boolean
	isLoading: boolean
	fetchPermissions: () => Promise<void>
	hasPermission: (permission: string | undefined) => boolean
	hasAnyPermission: (permissions: string[]) => boolean
}

export const usePermissionStore = create<PermissionState>((set, get) => ({
	permissions: [],
	isSuperAdmin: false,
	isLoading: true,

	fetchPermissions: async () => {
		try {
			const data = await permissionsApi.getUserPermissions()
			set({
				permissions: data.permissions || [],
				isSuperAdmin: data.is_super_admin || false,
				isLoading: false,
			})
		} catch (error) {
			set({ permissions: [], isSuperAdmin: false, isLoading: false })
			throw error
		}
	},

	hasPermission: (permission) => {
		if (!permission) return true
		const { isSuperAdmin, permissions } = get()
		return isSuperAdmin || permissions.includes(permission)
	},

	hasAnyPermission: (perms) => {
		const { isSuperAdmin, permissions } = get()
		if (isSuperAdmin) return true
		return perms.some(p => permissions.includes(p))
	},
}))
// 获取用户 Dashboard 角色
export function getDashboardRole(user: { is_super_admin?: boolean; crmeb_uid?: number | null } | null): import('@/types/dashboard').UserRole {
	if (!user) return 'department_user'
	if (user.is_super_admin) return 'super_admin'
	if (user.crmeb_uid) return 'supplier'
	return 'department_user'
}
